import * as React from 'react'
import { MainBlock } from '@blocks/BlockMain/model'
import { DisclaimerMain } from '@shared/components/disclaimer-main'

import { PagesPath, pagesTitles } from './pages-titles'

export const mainBlock: MainBlock = {
	title: pagesTitles[PagesPath.loan].mainBlockTitle,
	textItems: [
		'Срок — до 20 лет',
		'Лояльны к кредитной истории',
		'Работаем под надзором ЦБ РФ',
		'Вы остаетесь собственником ',
	],
	buttonText: 'Оставить заявку',
	footDisclaimer: <DisclaimerMain />,
	faceImageName: {
		mobile: 'KV-loans-business-mob.png',
		default: 'keyvisual-loans-business.png',
	},
	imageAlt: 'Владимир Холодилов, руководитель отдела по работе с клиентами',
	isActiveAndornment: true,
	isAverageImg: false,
}
